'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/SureDesignSystem/Accordion/Accordion.js';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _AccordionItem = require('./AccordionItem');

var _AccordionItem2 = _interopRequireDefault(_AccordionItem);

var _AccordionModule = require('./Accordion.module.css');

var _AccordionModule2 = _interopRequireDefault(_AccordionModule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  className: _propTypes2.default.string,
  itemClassName: _propTypes2.default.string,
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.number,
    title: _propTypes2.default.string,
    description: _propTypes2.default.string
  })),
  activeItemId: _propTypes2.default.number
};
var defaultProps = {
  className: null,
  itemClassName: null,
  items: [],
  activeItemId: null
};

var Accordion = function (_React$PureComponent) {
  _inherits(Accordion, _React$PureComponent);

  function Accordion(props) {
    _classCallCheck(this, Accordion);

    var _this = _possibleConstructorReturn(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call(this, props));

    _this.onToggle = function (item) {
      if (_this.state.activeItemId === item.id) {
        _this.setState({
          activeItemId: null
        });
      } else {
        _this.setState({
          activeItemId: item.id
        });
      }
    };

    _this.state = {
      activeItemId: props.activeItemId || null
    };
    return _this;
  }

  _createClass(Accordion, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var activeItemId = this.state.activeItemId;
      var _props = this.props,
          className = _props.className,
          itemClassName = _props.itemClassName,
          items = _props.items;
      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)(_AccordionModule2.default.wrapper, className),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 57
        },
        __self: this
      }, (0, _map2.default)(items, function (item) {
        return _react2.default.createElement(_AccordionItem2.default, {
          key: item.id,
          item: item,
          className: itemClassName,
          isOpen: item.id === activeItemId,
          onToggle: _this2.onToggle,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 59
          },
          __self: _this2
        });
      }));
    }
  }]);

  return Accordion;
}(_react2.default.PureComponent);

Accordion.propTypes = propTypes;
Accordion.defaultProps = defaultProps;
exports.default = Accordion;